import { useEffect, useState } from "react";
import { Form as FormikForm, useFormikContext } from "formik";
import { Grid, TextField, Button, MenuItem, InputAdornment, FormControlLabel, Switch } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import { CustomField } from '../../../inputs/CustomField';
import { useAxios } from "../../../../context/AxiosHookContext";

export const TicketForm = ({ onClose }) => {

    const { values, isSubmitting, setFieldValue } = useFormikContext();
    const [categoriaList, setCategoriasList] = useState([]);
    const [subCategoriaList, setSubCategoriaList] = useState([]);

    const axios = useAxios();


    const getSupportTypes = async () => {
        try {
            const types = JSON.stringify(["support_type"])
            const { data } = await axios.get(`/tickets/category?page=1&limit=50000&types=${types}`);
            setCategoriasList(data.data.list)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getSupportTypes()
    }, [values])



    useEffect(() => {
        const getSupportSubTypes = async () => {
            try {
                const types = JSON.stringify(["support_subtype"])
                const { data } = await axios.get(`/tickets/category?page=1&limit=50000&types=${types}`);
                setSubCategoriaList(data.data.list)
            } catch (error) {
                console.log(error)
            }
        }

        getSupportSubTypes()
    }, [])


    return (
        <FormikForm>
            <Grid container spacing={2} >

                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <CustomField name="type" label="Tipo de categoría:" select fullWidth as={TextField} >
                        <MenuItem value="support_type">Categoría</MenuItem>
                        <MenuItem value="support_subtype">Subtipo de categoría</MenuItem>
                        <MenuItem value="support_subtype_1">Subtipo técnico</MenuItem>
                    </CustomField>
                </Grid>


                {values?.type === "support_subtype" &&
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <CustomField name="father" label="Selecciona la categoría:" select fullWidth as={TextField}

                        >
                            {categoriaList.length > 0 && categoriaList.map((cat, key) => (
                                <MenuItem key={key} value={cat._id}>{cat.displayName}</MenuItem>
                            ))
                            }
                        </CustomField>
                    </Grid>
                }

                {values?.type === "support_subtype_1" &&
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <CustomField name="father" label="Selecciona el subtipo de categoría:" select fullWidth as={TextField}>
                            {subCategoriaList.length > 0 && subCategoriaList.map((cat, key) => (
                                <MenuItem key={key} value={cat._id}>{cat.displayName}</MenuItem>
                            ))
                            }
                        </CustomField>
                    </Grid>
                }

                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <CustomField name="displayName" label="Descripción de la categoría." fullWidth as={TextField} />
                </Grid>

                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={values.active ?? true}
                                onChange={(e) => setFieldValue('active', e.target.checked)}
                            />
                        }
                        label={values.active ?? true ? "Habilitado" : "Deshabilitado"}
                    />
                </Grid>


                <Grid item sm={12} textAlign={"right"} mt={3}>

                    <Button
                        variant="outlined"
                        onClick={() => onClose()}
                        disabled={!((values && !values?.status !== "Created") || false)}
                    >
                        cancelar
                    </Button>

                    <Button sx={{ marginLeft: 2 }}
                        variant="contained"
                        type="submit"
                        disabled={isSubmitting}
                    >
                        {isSubmitting && <CircularProgress size={"15px"} sx={{ color: "white", marginRight: "6px" }} />}
                        {isSubmitting ? 'Guardando' : 'Guardar'}
                    </Button>

                </Grid>

            </Grid>

        </FormikForm>



    );
}

export default TicketForm;